module.exports = __webpack_public_path__ + "img/boggy-reflections_2022-01-10.png";